import { Location } from "../../objects/management/locationManagement/location";
import { OrderLocation } from "../../objects/management/order/orderLocation";

/**
 * Created by alex.y on 8/10/2017.
 */
export class LocationUtil {

    public static formatAddress(location: OrderLocation, showState: boolean = false): string {
        let result = '';

        if (!location)
            return result;

        if (location.Street)
            result += `${location.Street}, `;

        if (location.City)
            result += `${location.City}, `;

        if (showState && location.State)
            result += `${location.State}, `;

        if (location.Zip)
            result += `${location.Zip}, `;

        if (location.Country)
            result += location.Country;

        return result;
    }

    public static getShipmentTo(locations: OrderLocation[]) {
        if (!locations)
            return null;

        return locations.find(x => x.Type == 2);
    }

    public static getShipmentFrom(locations: OrderLocation[]) {
        if (!locations)
            return null;

        return locations.find(x => x.Type == 1);
    }

}


// WEBPACK FOOTER //
// ./app/common/utils/LocationUtil.ts